var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7812 4.21875L10.125 2.85937C9.98438 2.53125 9.65625 2.34375 9.28125 2.34375H5.76563C5.39063 2.34375 5.0625 2.53125 4.92188 2.85937L4.21875 4.21875H2.34375C1.82812 4.21875 1.40625 4.64062 1.40625 5.15625V11.7188C1.40625 12.2344 1.82812 12.6562 2.34375 12.6562H12.6562C13.1719 12.6562 13.5938 12.2344 13.5938 11.7188V5.15625C13.5938 4.64062 13.1719 4.21875 12.6562 4.21875H10.7812Z",
    stroke: "#5F6368",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.7812C9.0533 10.7812 10.3125 9.52205 10.3125 7.96875C10.3125 6.41545 9.0533 5.15625 7.5 5.15625C5.9467 5.15625 4.6875 6.41545 4.6875 7.96875C4.6875 9.52205 5.9467 10.7812 7.5 10.7812Z",
    stroke: "#5F6368",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34375 5.625H3.75",
    stroke: "#5F6368",
    strokeWidth: 0.9375,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.35f5a1c411635b1450310f42609301e6.svg";
export { ForwardRef as ReactComponent };